import React from "react";
import './blog.css'

import "swiper/swiper-bundle.min.css";
// import 'swiper/css/swiper.css'
import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Autoplay,
  Virtual,
} from "swiper";

// import { Swiper, SwiperSlide } from 'swiper';

import { Swiper, SwiperSlide } from "swiper/react";
import BlogSingle from "./BlogSingle";
import SectionTitle from "../../CommonComponents/SectionTitle.jsx/SectionTitle";


SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay, Virtual]);

const BlogTwo = () => {
  
  

 

  return (
    
    <section id="blog" className="blog section-bg pt-5">
      <div className="container">
    
        <SectionTitle
          title="Doctor Blogs"
          detail="Doctor blogs are essential for disseminating valuable medical information, promoting health awareness, and addressing common health concerns. They empower readers to make informed decisions and improve their well-being."
        />
    

   

    
        <Swiper
            spaceBetween={35}
            slidesPerView="auto"
            navigation={false}
            autoplay={true}
            key={Math.random()}
            
        >
        
            
              
            {[1,2,3,4,5,6].map((item,i) => (
                 <SwiperSlide key={i}>
                  <BlogSingle key={Math.random()}/>
                </SwiperSlide>
             )) }


             
              
               

          </Swiper>
      </div>    
   
 
  
    </section>      
          

  );
};

export default BlogTwo;

